<div class="ai-list-product-card flex column">
  <div class="top-half flex space-between default-padding row">
    <div class="top-left flex column">
      <p
        class="bold-font-weight font-size-16 black one-line-capitalize"
        [attr.data-cy]="'ingredient-name-' + viewModel?.lineNumber"
      >
        {{
          viewModel?.product?.summary?.categoryDescription ||
            viewModel?.aiListItem?.sourceText | lowercase
        }}
      </p>
      <p
        *ngIf="viewModel?.aiListItem?.sourceText !== 'Best Selling PIM Groups'"
        class="black"
        [attr.data-cy]="'source-text-' + viewModel?.lineNumber"
      >
        {{ 'i18n.lists.aiListProductCard.foundIn' | translate }}
        {{ viewModel?.aiListItem?.sourceText | translate }}
      </p>
      <p
        class="file-name black"
        [attr.data-cy]="'file-name-' + viewModel?.lineNumber"
      >
        <span class="black"
          >{{ 'i18n.lists.aiListProductCard.from' | translate }} </span
        ><span class="file-name-text">{{
          viewModel?.sourceFileDisplayText | translate
        }}</span>
      </p>
    </div>
    <div class="top-right flex column space-between">
      <ion-icon
        class="green icon-size close-outline-icon"
        [attr.data-cy]="'close-outline-' + viewModel?.lineNumber"
        slot="icon-only"
        name="close-outline"
      ></ion-icon>
      <p
        class="black font-size-12"
        [attr.data-cy]="'line-number-' + viewModel?.lineNumber"
      >
        {{ 'i18n.lists.aiListProductCard.line' | translate }}
        {{ viewModel?.lineNumber }}
      </p>
    </div>
  </div>
  <div
    class="bottom-half flex"
    [class.has-warning-drawer]="
      viewModel?.product?.drawerMsg?.isWarning ||
      viewModel?.product?.productCardWarningMsg?.display
    "
  >
    <ng-container *ngIf="viewModel?.loading; else failedMatchTemplate">
      <div class="loading-text flex full-width align-center justify-center">
        <p
          class="bold-font-weight"
          [attr.data-cy]="'loading-text-' + viewModel?.lineNumber"
        >
          {{ 'i18n.lists.aiListProductCard.findingProduct' | translate }}
        </p>
        <ion-spinner
          class="icon-size"
          name="circles"
          [attr.data-cy]="'loading-icon-' + viewModel?.lineNumber"
        ></ion-spinner>
      </div>
    </ng-container>

    <ng-template #failedMatchTemplate>
      <ng-container *ngIf="viewModel?.isMatchingFailed; else productTemplate">
        <div class="failed-template-section">
          <p
            class="bold-font-weight product-failed-text"
            [attr.data-cy]="'failed-text-' + viewModel?.lineNumber"
          >
            {{ 'i18n.lists.aiListProductCard.productFailedToLoad' | translate }}
          </p>
          <ion-icon
            class="green icon-size"
            [attr.data-cy]="'pencil-icon-' + viewModel?.lineNumber"
            src="assets/icon/pencil-green.svg"
            (click)="onEdit()"
            style="position: absolute; top: 1rem; right: 1rem"
          ></ion-icon>
        </div>
      </ng-container>
    </ng-template>

    <ng-template #productTemplate>
      <div class="full-width">
        <div class="drawer">
          <app-product-card-drawer
            [drawerMessage]="viewModel?.product?.drawerMsg"
            [warningMessage]="viewModel?.product?.productCardWarningMsg"
          >
          </app-product-card-drawer>
        </div>
        <div class="flex space-between default-padding row">
          <div class="product-image flex align-center justify-center">
            <app-product-card-image
              [isOnline]="isOnline"
              [imageThumbnail]="viewModel?.product?.imageThumbnail"
              [productNumber]="viewModel?.product?.productNumber"
              [clickable]="!viewModel?.product?.notFound"
              (productImageClickEmitter)="onProductClick()"
            ></app-product-card-image>
          </div>
          <div class="product-details">
            <app-product-card-information
              [brand]="viewModel?.product?.summary?.brand"
              [description]="viewModel?.product?.summary?.productDescTxtl"
              [productNumber]="viewModel?.product?.productNumber"
              [salesPackSize]="viewModel?.product?.summary?.salesPackSize"
              [showNote]="false"
              [notFound]="viewModel?.product?.notFound"
              [customerProductNumber]="
                viewModel?.product?.customerProductNumber
              "
              [showPowerReview]="false"
              [pricePerPortion]="viewModel?.product?.pricePerPortion"
              (productDescriptionClickEmitter)="onProductClick()"
              [clickable]="true"
              [isGuestUser]="false"
            >
            </app-product-card-information>
          </div>
          <div class="edit">
            <ion-icon
              class="green icon-size"
              [attr.data-cy]="'pencil-icon-' + viewModel?.lineNumber"
              src="assets/icon/pencil-green.svg"
              (click)="onEdit()"
            ></ion-icon>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</div>
